import { gql } from '@apollo/client';

const AI_LIST_PROMPTS_QUERY = gql`
    query ListPrompts($page: Int, $limit: Int, $orderBy: String, $orderDir: String) {
        prompts(page: $page, limit: $limit, orderBy: $orderBy, orderDir: $orderDir) {
            edges {
                id
                companyId
                label
                prompt
                sql
                isSaved
                reportCount
                createdAt
                updatedAt
                isValid
            }
            pageInfo {
                orderBy
                orderDir
                pageCount
                totalCount
                totalPages
            }
        }
    }
`;

export default AI_LIST_PROMPTS_QUERY;
